export const mediaABMAssignments = {
    read(mediaId, options) {
        return $.getJSON(AdminRoutes.adminMediaABMAssignmentsPath(mediaId, options));
    },

    destroyMultiple(mediaId, ids) {
        return $.ajax({
            method:      'POST',
            dataType:    'json',
            contentType: "application/json",
            url:         AdminRoutes.revokeMultipleAdminMediaABMAssignmentsPath(mediaId),
            data:        JSON.stringify({ ids })
        })
    },
}